import React, { useState } from "react"
import { useScrollReveal, deriveTopics } from "../utils"

// TopicCard grid component — kept for future use
// function TopicCard({ topic }) {
//   const [hovered, setHovered] = useState(false)
//   return (
//     <div
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       style={{
//         background: hovered ? "#FF4000" : "#fff",
//         height: 100,
//         display: "flex",
//         alignItems: "flex-end",
//         padding: "16px 28px",
//         boxSizing: "border-box",
//         cursor: "default",
//         transition: "background 0.2s ease",
//       }}
//     >
//       <span style={{
//         fontFamily: "Inter, system-ui, -apple-system, sans-serif",
//         fontSize: 28,
//         fontWeight: 500,
//         lineHeight: 1.2,
//         color: "#000",
//         transition: "color 0.2s ease",
//       }}>
//         {topic}
//       </span>
//     </div>
//   )
// }

export function TopicsBlock({ programme }) {
  const ref = useScrollReveal()

  const pathway = programme.mentor_pathway
  const topics = pathway ? pathway.topics : deriveTopics(programme.sessions)

  if (!topics?.length) return null

  const paragraphs = pathway?.description
    ? pathway.description.split("\n\n")
    : ["Sessions are not pre-fixed. Topics are selected based on assessment results (individual profiles and cohort-wide patterns). Candidate topics include:"]

  const half = Math.ceil(topics.length / 2)
  const col1 = topics.slice(0, half)
  const col2 = topics.slice(half)

  return (
    <div ref={ref} style={{ padding: "80px 60px 0", boxSizing: "border-box" }}>
      <div style={{ borderTop: "1px solid rgba(255,255,255,0.12)", paddingTop: 60 }}>
        <p style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", color: "#fff", margin: "0 0 28px" }}>
          {pathway?.title || "How development topics are chosen"}
        </p>
        <div style={{ marginBottom: 48 }}>
          {paragraphs.map((para, i) => (
            <p key={i} style={{ fontSize: 16, lineHeight: 1.7, color: "#fff", maxWidth: 620, margin: i < paragraphs.length - 1 ? "0 0 16px" : 0 }}>
              {para}
            </p>
          ))}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 60px" }}>
          {[col1, col2].map((col, ci) => (
            <ul key={ci} style={{ listStyle: "none", margin: 0, padding: 0 }}>
              {col.map((topic, i) => (
                <li key={i} style={{
                  fontSize: 16,
                  lineHeight: 1.6,
                  color: "#fff",
                  padding: "10px 0",
                  borderBottom: "1px solid rgba(255,255,255,0.07)",
                }}>
                  {topic}
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
    </div>
  )
}
